import './App.css';
import { ConfigProvider, theme } from 'antd';
import { Routes, Route, useLocation } from 'react-router-dom';

import Home from './pages/home/main';
import HomeV2 from './pages/homev2/main';
import Automations from './pages/automate/main';
import Signup from './pages/login/main';
import InstaAccounts from './pages/instaAccounts/main';
import SignupTwo from './pages/signup/main';
import Oia from './pages/oia/main';

import FbRdr from './pages/fb-redirect/main';
import FbAPIRdr from './pages/fb-api-redirect/main';
import { Alert } from 'antd';
import ResetPassword from './pages/reset-password/main';
import YT from './pages/yt-automation/main';
import InboxAutomation from './pages/inbox-automation/main';
import LinkExtract from './pages/linkExtract/main'
// import Shop from './pages/shop/main';
import CollectMoney from './pages/collect-amount/main';
import FlowComp from './pages/flow-automte/main';
import AutomationList from './pages/automationList/main';

import RefferalList from './pages/referal_board/main';
import LinkedIn from './pages/linkedin/main';

import SellMain from './sell_pages/main/main';
import Courses from './pages/courses/main';
import CoursePurchaseFlow from './pages/course_client_side/main';
import IDMDashboard from './pages/dashboard/main';
import DigitalProducts from './pages/digital-products/main';
import DigitalPurchaseFlow from './pages/digital_product_client_side/main';
import Shopify from './pages/shopify/main';
import SPConnectAPP from './pages/shopify-connect-app/main';
import SPRDR from './pages/shopify-redirect/main';
import SPLOGIN from './pages/shopify-login/main';
import IGAUTHAPP from './pages/ig-auth-app/main';
import { useEffect } from 'react';

import FBHome from './pages/fb-home/main';
import MessengerPage from './pages/messagner/main';
import InstagramPostUploader from './pages/later/mani';
import WelcomeOnboardingPage from './pages/welcome/main';
import CollabInvite from './pages/collab-invite/main';
import StripeSuccess from './pages/stripe-success/main';
import StripeFailure from './pages/stripe-failure/main';
import WhatsAppFloat from './comps/whatsappFloat/main';
import NotFoundPage from './pages/not-found/main';
import SharedFlowPage from './pages/shared-flow/main';

import { trackPageView } from './funcs/metaPixel';




const getDomainConfig = () => {
  const hostname = window.location.hostname;

  switch (hostname) {
    case "app.instantdm.com":
      return {
        button: { style: { borderRadius: 4, background: "#1677ff", color: "#fff" } },
        input: { style: { borderRadius: 4 } },
        modal: { style: { borderRadius: 4 } }
      };

    case "localhost":
      return {
        theme: {
          "token": {
            "wireframe": false,
            "colorPrimary": "#000000",
            "colorInfo": "#000000",
            "colorSuccess": "#2588e4"
          },
          "components": {

            Tag: {

              defaultBg: "#f0f0f0",             // background of default tag
              defaultColor: "#000000",          // text color of default tag

            }
          }
        },
        button: { style: { borderRadius: 0, background: "black", color: "#fff" } },
        input: { style: { borderRadius: 12 } },
        modal: { style: { borderRadius: 12 } },
        radio: {
          colorPrimary: "#ff4d4f", // radio checked color
          algorithm: true
        },



      };

    default:
      return {
        button: { style: { borderRadius: 4 } },
        input: { style: { borderRadius: 4 } },
        modal: { style: { borderRadius: 4 } }
      };
  }
};





function App() {
  const config = getDomainConfig();
  const location = useLocation();

  // Track page views on route changes for Meta Pixel
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  useEffect(() => {

    try {
      let user_detail = JSON.parse(localStorage.getItem("userData"))
      let user_id = user_detail?.user_id
      if (user_id) {
        window.clarity("identify", user_id);
      }
    }
    catch (err) {
      console.log("error in user details", err)
    }

  })

  return (
    <ConfigProvider
    // {...config}
    >
      <div className="App">

        <Routes>
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Signup />} />
          <Route path="/ig-connect" element={<SignupTwo />} />
          <Route path="/fb-rdr" element={<FbAPIRdr />} />
          <Route path="/fb-api-rdr" element={<FbAPIRdr />} />
          <Route path="/ig_auth_app" element={<IGAUTHAPP />} />
          <Route path="/insta-accounts" element={<InstaAccounts />} />
          <Route path='/' element={<WelcomeOnboardingPage />} />
          <Route path='/fb' element={<FBHome />} />

          <Route path="/ig" element={<HomeV2 />} />
          <Route path="/dashboard" element={<IDMDashboard />} />
          <Route path='/messenger' element={<MessengerPage />} />

          {/* <Route path="/home" element={<Home />} /> */}
          <Route path="/manage-post/:id" element={<Automations />} />
          <Route path="/oia" element={<Oia />} />
          <Route path='/reset-password' element={<ResetPassword />} />
          <Route path="/yt" element={<YT />} />
          <Route path="/inbox-automation" element={<InboxAutomation />} />
          <Route path="/le" element={<LinkExtract />} />
          {/* <Route path="/shop2" element={<Shop/>} /> */}
          <Route path="/shop" element={<SellMain />} />

          <Route path="/shopify" element={<Shopify />} />
          <Route path="/connect-shopify-store" element={<SPConnectAPP />} />
          <Route path="/shopfy-rdr" element={<SPRDR />} />
          <Route path="/shopfy-login" element={<SPLOGIN />} />

          <Route path="/cm" element={<CollectMoney />} />
          <Route path="/flow" element={<FlowComp />} />
          <Route path="/automation-list" element={<AutomationList />} />
          <Route path="/referral-dashboard" element={<RefferalList />} />

          <Route path="/linkedin" element={<LinkedIn />} />
          <Route path='/courses' element={<Courses />} />
          <Route path='/digital-products' element={<DigitalProducts />} />
          <Route path='/course/id' element={<CoursePurchaseFlow />} />
          <Route path='/dp/:id' element={<DigitalPurchaseFlow />} />
          <Route path='/msg' element={<MessengerPage />} />
          <Route path='/later' element={<InstagramPostUploader />} />
          <Route path="/c/:id" element={<CollabInvite />} />
          <Route path="/shared-flow/:id" element={<SharedFlowPage />} />
          <Route path="/stripe-success" element={<StripeSuccess />} />
          <Route path="/stripe-failure" element={<StripeFailure />} />

          <Route path="/collab-order-success" element={<StripeSuccess />} />
          <Route path="/collab-order-cancel" element={<StripeFailure />} />

          {/* 404 - Catch all unknown routes */}
          <Route path="*" element={<NotFoundPage />} />

        </Routes>
        <WhatsAppFloat />
      </div>
    </ConfigProvider>
  );
}

export default App;

